import React from 'react';
import './DigitalMarketing.css';

const DigitalMarketing = () => {
  const benefits = [
    {
      title: 'Support Brand Value',
      description: 'Digital marketing firms assist your company in expanding its reach and making your offerings stand out in a competitive market.'
    },
    {
      title: 'Boost User Relationships',
      description: 'Our analytics helps to identify core user needs and target the right audience through data-driven campaigns.'
    },
    {
      title: 'Drive More Traffic',
      description: 'Effective digital marketing strategies open up multiple cross-channel business opportunities for exceptional reach.'
    },
    {
      title: 'Stay on Top',
      description: 'Marketing solutions help you maintain visibility across all relevant platforms with consistent messaging and targeting.'
    },
    {
      title: 'Increase in Competition',
      description: 'Expert-led marketing campaigns empower SMEs to compete directly with large enterprises at scale.'
    },
    {
      title: 'Improve Conversion Rates',
      description: 'Turn leads into paying customers with optimized funnels, personalized content, and retargeting techniques.'
    },
    {
      title: 'Cost-Effective',
      description: 'Digital marketing is often more affordable than traditional methods, providing better ROI through targeted campaigns.'
    },
    {
      title: 'Measure Success',
      description: 'Track and analyze campaign performance in real-time to make data-driven decisions and optimize strategies.'
    }
  ];

  return (
    <section className="digital-marketing-section">
      <div className="background-animation"></div>
      <section className="graphic-design-section">
        <div className="container">
          <div className="graphic-design-content">
            <img src={require('../assets/Sushi (1).png')} alt="Graphic Design" className="graphic-design-image" />
            <div className="graphic-design-text">
              <h2>Graphic Design Services</h2>
              <p>Enhance your brand with stunning visual designs that captivate your audience and communicate your message effectively.</p>
              <p className="additional-text">Our creative team delivers high-quality graphics for logos, brochures, websites, and more to make your business stand out.</p>
            </div>
          </div>
        </div>
      </section>
      <h2>Why Your Business Needs Digital Marketing Services?</h2>
      <div className="marketing-benefits">
        {benefits.map((benefit, index) => (
          <div className="benefit-card" key={index}>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DigitalMarketing;
